import React from "react";
import mobile from "../assets/mobile.png";
import { FaLock, FaFileAlt, FaEye } from "react-icons/fa";
import { Link } from 'react-router-dom'; 

export default function Banner() {
  return (
    <div className="bg-blue-900 flex flex-col items-center py-16 px-4 md:px-0">
      <div className="max-w-[1240px] mx-auto flex flex-col md:flex-row items-center md:items-start justify-between w-full">
        <div className="flex flex-col items-center md:items-start text-center md:text-left mb-10 md:mb-0">
          <h1 className="text-2xl md:text-4xl font-bold mx-8  my-2 mt-20 text-white">Revolutionizing Digital</h1>
          <h1 className="text-2xl md:text-4xl font-bold mx-8 my-2 text-white">Landscapes With Secure,</h1>
          <h1 className="text-2xl md:text-4xl font-bold mx-8 my-2 text-white">Transparent, Decentralized</h1>
          <h1 className="text-2xl md:text-4xl font-bold mx-8 my-2 text-white">Solutions For All.</h1>
          <Link to="/blog" className="bg-customColor text-white mx-8 px-6 py-3 rounded mt-4">Read More</Link>
        </div>
        <div className="flex justify-center md:justify-end w-full md:w-auto">
          <img src={mobile} alt="mobile illustration" className="w-full md:w-auto h-auto" />
        </div>
      </div>
      <div className="w-full max-w-[1240px] bg-[#001A66] p-6 mt-10 flex flex-col md:flex-row justify-around items-center">
        <div className="flex flex-col items-center text-white">
          <FaLock className="text-4xl" />
          <p className="mt-4 font-bold">SECURITY</p>
        </div>
        <div className="flex flex-col items-center text-white">
          <FaFileAlt className="text-4xl" />
          <p className="mt-4 font-bold">IMMUTABILITY</p>
        </div>
        <div className="flex flex-col items-center text-white">
          <FaEye className="text-4xl" />
          <p className="mt-4 font-bold">TRANSPARENCY</p>
        </div>
      </div>
    </div>
  );
}
